import { LockOutlined } from '@ant-design/icons';
import {
  Table as ATable,
  Divider,
  Tag,
  Tooltip,
  Typography,
  message,
} from 'antd';
import colors from '../../../constants/ColourConstants';
import { handlePayoutPeriod } from '../../../utils/helpers/helper';
import { getTransactionByInvoiceId } from '../../../services/InvoiceAPIs';
const getStatusType = (status) => {
  return (
    {
      'Contributor Approved': 'default',
      'Pending PM Approval': 'default',
      'Under Further Review': 'default',
      Voided: 'default',

      'Ready for Finance Review': 'cyan',
      'Ready for Invoice': 'cyan',
      'Added to Invoice': 'cyan',
      'Added to Payout': 'cyan',

      'Payout Pending': 'warning',

      'Payout Failure': 'error',

      'Payout Completed': 'success',
    }[status] || 'default'
  );
};
export const ExpandedRow = (
  parent_record,
  expandedRecords,
  loader,
  setExpandedRecords,
  transactionsLoader,
  SetTransactionsLoader,
  oldPayoutExpandedRowKeys,
  setOldPayoutExpandedRowKeys,
) => {
  const { Text } = Typography;

  const payout_columns = [
    ATable.EXPAND_COLUMN,
    {
      title: 'Payout ID',
      dataIndex: 'payoutId',
      key: 'payoutId',
      width: 155,
      render: (value) => {
        return (
          <Tooltip
            title={
              <>
                {value} {<LockOutlined />}
              </>
            }
          >
            <Text
              style={{
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                color: colors.colorText,
              }}
            >
              {value}
              <LockOutlined
                style={{
                  marginLeft: 8,
                  fontSize: '16px',
                  color: colors.colorIcon,
                }}
              />
            </Text>
          </Tooltip>
        );
      },
      sorter: (a, b) => a.payoutId?.localeCompare(b.payoutId),
    },
    {
      title: 'Created Date',
      dataIndex: 'createdDate',
      key: 'created_date',
      width: 160,
      render: (value) => {
        const created_date = value ? value.split('T')[0] : null;
        return (
          <Text
            style={{
              color: colors.colorText,
            }}
          >
            {created_date}
          </Text>
        );
      },
      sorter: (a, b) => a.createdDate?.localeCompare(b.createdDate),
    },
    {
      title: 'Payout Closed',
      dataIndex: 'completedDate',
      key: 'closed_date',
      width: 160,
      render: (value) => {
        const closed_date = value ? value.split('T')[0] : null;
        return (
          <Text
            style={{
              color: colors.colorText,
            }}
          >
            {closed_date}
          </Text>
        );
      },
      sorter: (a, b) => a.completedDate?.localeCompare(b.completedDate),
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      width: 150,
      render: (value) => {
        return (
          <Text
            style={{
              color: colors.colorText,
              float: 'right',
            }}
          >
            {`$ ${value?.toFixed(2)}`}
          </Text>
        );
      },
      sorter: (a, b) => a.payoutAmount - b.payoutAmount,
    },
    {
      title: 'Payout Rail',
      dataIndex: 'payoutRail',
      key: 'payout_rail',
      width: 150,
      render: (value) => {
        return (
          <Text
            style={{
              color: colors.colorText,
            }}
          >
            {value}
          </Text>
        );
      },
      sorter: (a, b) => a.payoutRail?.localeCompare(b.payoutRail),
    },
    {
      title: 'Payout Period',
      dataIndex: 'payoutPeriod',
      key: 'payout_period',
      width: 160,
      render: (value) => {
        const date = handlePayoutPeriod(value);
        return (
          <Text
            style={{
              color: colors.colorText,
            }}
          >
            {date}
          </Text>
        );
      },
      sorter: (a, b) => a.payoutPeriod?.localeCompare(b.payoutPeriod),
    },
    {
      title: 'Payout Status',
      dataIndex: 'status',
      key: 'payout_status',
      width: 240,
      render: (value, record) => {
        return (
          <Tooltip title={value}>
            <Text
              style={{
                width: 240,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                color: colors.colorText,
              }}
            >
              <Tag color={getStatusType(value)}>{value}</Tag>

              {record.reattempted && (
                <>
                  <br /> <Tag>Regenerated</Tag>
                </>
              )}
            </Text>
          </Tooltip>
        );
      },
      sorter: (a, b) => a.status?.localeCompare(b.status),
    },
    {
      title: 'Attempt',
      dataIndex: 'attempt',
      key: 'attempt',
      width: 210,
      render: (value, record) => {
        const { reattempted, reattemptStatus, reattemptStatusType } = record;
        return (
          <Text
            style={{
              color: colors.colorText,
              display: 'flex',
            }}
          >
            <Tag>{value}</Tag>
            <Tag color={reattemptStatusType}>{reattemptStatus}</Tag>
          </Text>
        );
      },
      sorter: (a, b) => a.attempt?.localeCompare(b.attempt),
    },
    {
      title: 'Failure Reason',
      dataIndex: 'failedReason',
      key: 'failure_Reson',
      width: 180,
      render: (value) => (
        <Tooltip title={value}>
          <Text
            style={{
              width: 170,
              display: 'block',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              color: colors.colorText,
            }}
          >
            {value}
          </Text>
        </Tooltip>
      ),
      sorter: (a, b) => a.failedReason?.localeCompare(b.failedReason),
    },
  ];

  const invoice_columns = [
    ATable.EXPAND_COLUMN,
    {
      title: 'Invoice ID',
      dataIndex: 'invoiceId',
      key: 'invoice_Id',
      width: 120,
      render: (value) => {
        return (
          <Tooltip
            title={
              <>
                {value} {<LockOutlined />}
              </>
            }
          >
            <Text
              style={{
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                color: colors.colorText,
              }}
            >
              {value}
              <LockOutlined
                style={{
                  marginLeft: 8,
                  fontSize: '16px',
                  color: colors.colorIcon,
                }}
              />
            </Text>
          </Tooltip>
        );
      },
      sorter: (a, b) => a.invoiceId?.localeCompare(b.invoiceId),
    },
    {
      title: 'Created Date',
      dataIndex: 'createdDate',
      key: 'createdDate',
      width: 100,
      render: (value) => {
        const created_date = value ? value.split('T')[0] : null;
        return (
          <Text
            style={{
              color: colors.colorText,
            }}
          >
            {created_date}
          </Text>
        );
      },
      sorter: (a, b) => a.createdDate?.localeCompare(b.createdDate),
    },
    {
      title: 'Last Modified',
      dataIndex: 'modifiedDate',
      key: 'modified_date',
      width: 100,
      render: (value) => {
        const closed_date = value ? value.split('T')[0] : null;
        return (
          <Text
            style={{
              color: colors.colorText,
            }}
          >
            {closed_date}
          </Text>
        );
      },
      sorter: (a, b) => a.modifiedDate?.localeCompare(b.modifiedDate),
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      width: 100,
      render: (value) => {
        return (
          <Text
            style={{
              color: colors.colorText,
              float: 'right',
            }}
          >
            {`$ ${value?.toFixed(2)}`}
          </Text>
        );
      },
      sorter: (a, b) => a.amount - b.amount,
    },
    {
      title: 'Invoice Status',
      dataIndex: 'invoiceStatus',
      key: 'invoice_Status',
      width: 100,
      render: (value) => {
        return (
          <Tooltip title={value}>
            <Text
              style={{
                width: 160,
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                color: colors.colorText,
              }}
            >
              <Tag color={getStatusType(value)}>{value}</Tag>
            </Text>
          </Tooltip>
        );
      },
      sorter: (a, b) => a.invoiceStatus?.localeCompare(b.invoiceStatus),
    },
  ];

  const transaction_columns = [
    {
      title: 'Transaction ID',
      dataIndex: 'transactionId',
      key: 'transaction_Id',
      width: 220,
      render: (value) => {
        return (
          <Tooltip
            title={
              <>
                {value} {<LockOutlined />}
              </>
            }
          >
            <Typography.Text
              style={{
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {value}
              <LockOutlined
                style={{
                  marginLeft: 8,
                  fontSize: '16px',
                  color: colors.colorIcon,
                }}
              />
            </Typography.Text>
          </Tooltip>
        );
      },
      sorter: (a, b) => a.transactionId?.localeCompare(b.transactionId),
    },
    {
      title: 'Type',
      dataIndex: 'transactionType',
      key: 'transaction_Type',
      width: 220,
      render: (value) => <>{value}</>,
      sorter: (a, b) => a.transactionType?.localeCompare(b.transactionType),
    },
    {
      title: 'Amount(in USD)',
      dataIndex: 'transactionAmount',
      key: 'transaction_Amount',
      width: 240,
      render: (value) => {
        return (
          <Text
            style={{
              color: colors.colorText,
              float: 'right',
            }}
          >
            {`$ ${value?.toFixed(2)}`}
          </Text>
        );
      },
      sorter: (a, b) => a.transactionAmount - b.transactionAmount,
    },
    {
      title: 'Status',
      dataIndex: 'transactionStatus',
      key: 'transaction_Status',
      width: 220,
      render: (value, row) => {
        return <Tag color={row.statusVarient}>{value}</Tag>;
      },
      sorter: (a, b) => a.transactionStatus?.localeCompare(b.transactionStatus),
    },
    {
      title: 'Date',
      dataIndex: 'transactionDate',
      key: 'transaction_Date',
      width: 220,
      render: (value) => <>{value}</>,
      sorter: (a, b) => a.transactionDate?.localeCompare(b.transactionDate),
    },
  ];

  const handleInvoicesTable = (from) => {
    return (
      <div
        style={{
          padding: '2px 48px',
          background: from === 'old_payout' && colors.colorSplit,
        }}
      >
        <Text>
          <Text
            style={{
              size: '18px',
              fontWeight: 600,
              lineHeight: '39px',
            }}
          >
            Associated Invoices
          </Text>
        </Text>
        <ATable
          bordered={true}
          pagination={false}
          style={{
            marginBottom: 0,
            width: from === 'old_payout' ? '135vh' : '150vh',
            border: '1px solid',
          }}
          loading={loader}
          columns={invoice_columns}
          dataSource={expandedRecords[parent_record.payoutId]?.invoices}
          expandable={{
            showExpandColumn: false,
            expandedRowRender: (record) => {
              return (
                <div
                  style={{
                    margin: '0px',
                    padding: '4px 22px',
                    background: colors.colorSplit,
                  }}
                >
                  <Text>
                    <Text
                      style={{
                        size: '18px',
                        fontWeight: 600,
                        lineHeight: '39px',
                      }}
                    >
                      Associated Transactions
                    </Text>
                  </Text>
                  <ATable
                    bordered={true}
                    pagination={false}
                    style={{ marginBottom: 0 }}
                    loading={transactionsLoader}
                    columns={transaction_columns}
                    dataSource={
                      expandedRecords[record.parent_key]?.transactions[
                        record.invoiceId
                      ]
                    }
                    scroll={{ y: 300 }}
                    size="middle"
                  />
                </div>
              );
            },
            onExpand: async (expanded, record) => {
              if (expanded) {
                if (
                  !expandedRecords[record.parent_key]?.transactions[
                    `${record.invoiceId}`
                  ]
                ) {
                  SetTransactionsLoader(true);
                  getTransactionByInvoiceId(record.invoiceId)
                    .then((res) => {
                      setExpandedRecords({
                        ...expandedRecords,
                        [`${record.parent_key}`]: {
                          ...expandedRecords[`${record.parent_key}`],
                          transactions: {
                            ...expandedRecords[`${record.parent_key}`]
                              .transactions,
                            [`${record.invoiceId}`]: res,
                          },
                        },
                      });
                    })
                    .catch(() => {
                      message.error('Failed to fetch invoice data');
                    })
                    .finally(() => {
                      SetTransactionsLoader(false);
                    });
                }
              }
            },
          }}
          scroll={{ y: 400 }}
          size="middle"
        />
      </div>
    );
  };

  const handlePayoutsTable = () => {
    return (
      <div
        style={{
          margin: '0px',
          padding: '4px 48px',
        }}
      >
        <Text>
          <Text
            style={{
              size: '18px',
              fontWeight: 600,
              lineHeight: '39px',
            }}
          >
            Payout Records
          </Text>
        </Text>
        <ATable
          bordered={true}
          pagination={false}
          style={{ marginBottom: 0, width: '150vh' }}
          loading={loader}
          columns={payout_columns}
          dataSource={expandedRecords[parent_record.payoutId]?.payouts}
          expandable={{
            showExpandColumn: false,
            expandedRowRender: () => handleInvoicesTable('old_payout'),
            expandedRowKeys: oldPayoutExpandedRowKeys,
            onExpand: (expanded, record) => {
              setOldPayoutExpandedRowKeys(expanded ? [record.key] : []);
            },
          }}
          scroll={{
            y: 400,
          }}
          size="middle"
        />
      </div>
    );
  };

  return (
    <div
      style={{
        margin: '0px',
        padding: '15px 0px',
        background: colors.colorSplit,
      }}
    >
      {handleInvoicesTable()}
      {expandedRecords[parent_record.payoutId]?.payouts?.length > 0 &&
        expandedRecords[parent_record.payoutId]?.invoices?.length > 0 && (
          <Divider style={{ margin: 8 }} />
        )}
      {expandedRecords[parent_record.payoutId]?.payouts?.length > 0 &&
        handlePayoutsTable()}
    </div>
  );
};
